module.exports = __webpack_public_path__ + "static/media/kenya-shipping-map.2109114b.jpg";